<template>
  <div class="foot-hd">
    <div class="ub ub-xc ub-ab">
      <div>
        <p>咨询：2890160（班内）2881989（班外）</p>
        <p>邮箱：lyszyybrfwzx@126.com</p>
        <p>院务公开意见邮箱：szyybgs@126.com</p>
        <p>院长接待日：每周二下午（门诊七楼接待室）</p>
        <p>版权所有：龙岩市中医院</p>
        <p>医院地址：福建省龙岩市新罗区龙腾中路59号</p>
        <p>邮政编码：364000</p>
        <p>中文域名：龙岩市中医院.公益 闽ICP备15019899号-5</p>
        <p>备案编号：闽ICP备15019899号-1</p>
        <p class="ub ub-xc"><img src="../../images/garz.png" style="margin-right:3px; width: 0.15rem"/>闽公网安备 35080202351358号</p>
      </div>
      <div ref="badgeContainer" class="footc">
<!--        <img src="../../images/zyy/sydw.png" alt="">-->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "tFoot",
    data() {
        return {
            footer: []
        }
    },
    mounted() {
      let base_info = this.getState('baseInfo');
      if(base_info!=null){
          this.footer = base_info.info;
      }
      this.loadIdentificationBadge();
    },
    methods: {
      loadIdentificationBadge() {
        const container = this.$refs.badgeContainer;
        if (!container) return;
        // 1.先插入span
        const span = document.createElement('span')
        span.id = '_ideConac'
        container.appendChild(span)
        // 2.动态创建script并插入DOM（动态script才会自动加载执行）
        const script = document.createElement('script')
        script.src = 'https://dcs.conac.cn/js/14/221/0000/41611099/CA142210000416110990003.js'
        script.type = 'text/javascript'
        container.appendChild(script)
      }
    }
  }
</script>

<style lang="scss">
.foot-hd{
  background: url("../../images/zyy/footbg.png") no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  line-height: 1.5;
  padding: 0.1rem;
  p{
    color: #fff;
    font-size: 12px;
  }
  .footc{
    width: 0.8rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/layout/foot.vue